var React = require('react');

function BookmarkFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M76 84L48 68L20 84V20C20 17.8783 20.8429 15.8434 22.3431 14.3431C23.8434 12.8429 25.8783 12 28 12H68C70.1217 12 72.1566 12.8429 73.6569 14.3431C75.1571 15.8434 76 17.8783 76 20V84Z","fill":"black","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

BookmarkFilled.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = BookmarkFilled;

BookmarkFilled.default = BookmarkFilled;
